import * as Yup from 'yup'
import { FormItemProps } from '@/components/Form/types'
//import GlbComponent from '@/components/UiElements/GlbComponent'
import React from 'react'
//import Text from '@/components/Form/elements/items/Text'
//import Preview3dPlugin from '@/components/ProductProfile/components/Preview3dPlugin'
import RuleForm from '@/components/Pricing/Components/RuleForm'

const Items: Array<FormItemProps> = [

	{
		name: 'id',
		type: 'Hidden',
	},
	{
		name: 'name',
		label: 'Name',
		type: 'Text',
		placeholder: 'Enter model name',
		validation: Yup.string().required('Required'),
		classNames: {
			container: 'col-span-6 break-line',
		}
	},
	{
		name: 'Divider1',
		type: 'Divider',
		classNames: {
			container: 'opacity-0 col-span-6',
		}
	},
	{
		name: 'price_model',
		label: 'Pricing Strategy',
		type: 'Select',
		placeholder: 'Select Strategy',
		itemOptions: {
			list: [
				{ label: 'Fixed Price for Product', value: 'FIXED' },
				{ label: 'Price Per Section', value: 'SECTION' },
				{ label: 'Price Per Element', value: 'ELEMENT' },
				{ label: 'Price Per Size', value: 'SIZE' },
			],
		},
		classNames: {
			container: 'col-span-6 break-line ',
		},
		validation: Yup.object().required('Required'),
	},
	{
		name: 'price',
		label: 'Base Price',
		//hint: 'Base price for the 3D model',
		type: 'Number',
		placeholder: 'Enter base price',
		validation: Yup.number().typeError('Required'),
		classNames: {
			container: 'col-span-6 ',
		}
	},
	{
		name: 'Divider3',
		type: 'Divider',
		label: '1. Tiered Rules (Exceptions)',
		classNames: {
			container: 'col-span-12 pt-xl',
		},
		condition: data => (data.price_model?.value !== 'FIXED'),
	},
	{
		name: 'rules',
		type: 'Preview',
		itemOptions: {
			preview: (props: any) => (
				<RuleForm {...props} />
			),
		},
		classNames: {
			container: 'col-span-12',
		},
		defaultValue: [],
		validation: Yup.array().of(
			Yup.object(
				{
					tier: Yup.string().required("Required"),
					price_rule: Yup.object().required("Required"),
					value: Yup.string().required("Required"),

				}
			)
		).optional(),
		condition: data => (data.price_model?.value !== 'FIXED'),

	},
	{
		name: 'Divider4',
		type: 'Divider',
		label: '2. Subsequent Rule (Default)',
		hint: 'This rule applies to all items *after* the tiered rules are used (e.g., for Tier 2, 3, 4... if you only set a rule for Tier 1).',
		classNames: {
			container: 'col-span-12  pt-xl',
		},
		condition: data => (data.price_model?.value !== 'FIXED'),
	},
	{
		name: 'price_rule',
		label: 'Rule Type',
		type: 'Select',
		placeholder: 'Select rule type',
		itemOptions: {
			list: [
				{ value: null, label: 'Not Selected' },
				{ value: 'FIXED_AMOUNT', label: 'Fixed Amount ($)' },
				{ value: 'PERCENTAGE_DISCOUNT', label: 'Percentage Discount (%)' },
				{ value: 'AMOUNT_DISCOUNT', label: 'Amount Discount ($)' },
				/*{ value: 'PERCENTAGE_OF_BASE', label: 'Percentage of Base Price (%)' },*/
			],
		},
		classNames: {
			container: 'col-span-6',
		},
		condition: data => (data.price_model?.value !== 'FIXED'),

	},
	{
		name: 'subsequentValue',
		label: 'Value',
		type: 'Number',
		placeholder: 'Enter value',
		classNames: {
			container: 'col-span-6',
		},
		condition: data => (data.price_model?.value !== 'FIXED' && data.price_rule?.value),
	},

	{
		name: 'Divider5',
		type: 'Divider',
		classNames: {
			container: 'col-span-12  pt-xl ',
		}
	},
	{
		name: 'min_price_total',
		label: 'Minimum Price',
		type: 'Number',
		placeholder: 'Enter minimum value for this pricing model',
		classNames: {
			container: 'col-span-6',
		},

	},
	{
		name: 'max_price_total',
		label: 'Maximum Price',
		type: 'Number',
		placeholder: 'Enter maximum value for this pricing model',
		classNames: {
			container: 'col-span-6',
		},

	},
	{
		name: 'Divider6',
		type: 'Divider',
		classNames: {
			container: 'col-span-12  pt-xl opacity-0',
		}
	},
	{
		name: 'save',
		type: 'Button',
		placeholder: 'Save Pricing Model',
		itemOptions: {
			buttonSize: 'lg',
			buttonLabel : 'Save Pricing Model',
		},
		classNames: {
			container: 'col-span-12 ',
		}
	},
]

export default Items


